export const NAME_TIME_ZONE = 'X-TimeZone';

export function getTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function getTimeZoneQuery(): string {
  return NAME_TIME_ZONE + '=' + getTimeZone();
}
